import { IPC_EVENT } from "@/ipc_events";
import Debugger from "../console/debugger";
import EventBus from "../event_bus";
import { CORNER, TOOLS } from "./tools";
import AppRenderer from "../app_renderer";
import { store } from "../../store";
import { settingStore } from "../store/settingStore";
import PainterProxy from "../painter/proxy";
import DEFINE from '../painter/define';
import { focusStore } from '../store/nowFocusStore';
import { TURN_PAGE_TYPE } from '../book_define/turn_page_type';
import { VIEW_TYPE } from "../view_type";

export default class PageTool {
    _bookPage = null;
    _exitDialog = null;
    constructor(bookPage, exitDialog) {
        this._bookPage = bookPage;
        this._exitDialog = exitDialog;
    }

    getToolFunction() {
        return [
            {
                key: TOOLS.GO_PAGE.TOOL,
                event: this.goPage()
            },
            {
                key: "go_left_page",
                event: this.goLeftPage()
            },
            {
                key: "go_right_page",
                event: this.goRightPage()
            },
            {
                key: "exit",
                event: this.exit()
            },
            {
                key: "directory",
                event: this.showDirectory()
            },
            {
                key: "go_page_by_index",
                event: this.goPageByIndex()
            },
            {
                key: TOOLS.ZOOM_IN.TOOL,
                event: this.zoomIn()
            },
            {
                key: TOOLS.ZOOM_OUT.TOOL,
                event: this.zoomOut()
            },
            {
                key: TOOLS.ZOOM_NORMAL.TOOL,
                event: this.zoomNormal()
            },
            {
                key: TOOLS.ZOOM_CORNER.TOOL + ":" + CORNER.LEFT_TOP,
                event: this.zoomCorner(TOOLS.ZOOM_CORNER.TOOL + ":" + CORNER.LEFT_TOP)
            },
            {
                key: TOOLS.ZOOM_CORNER.TOOL + ":" + CORNER.RIGHT_TOP,
                event: this.zoomCorner(TOOLS.ZOOM_CORNER.TOOL + ":" + CORNER.RIGHT_TOP)
            },
            {
                key: TOOLS.ZOOM_CORNER.TOOL + ":" + CORNER.LEFT_BOTTOM,
                event: this.zoomCorner(TOOLS.ZOOM_CORNER.TOOL + ":" + CORNER.LEFT_BOTTOM)
            },
            {
                key: TOOLS.ZOOM_CORNER.TOOL + ":" + CORNER.RIGHT_BOTTOM,
                event: this.zoomCorner(TOOLS.ZOOM_CORNER.TOOL + ":" + CORNER.RIGHT_BOTTOM)
            },
            {
                key: TOOLS.FULL_SCREEN.TOOL,
                event: this.switchFullScreenOrWindow()
            },
            {
                key: TOOLS.PAGE_MODE.TOOL,
                event: this.switchSingleOrDoublePage()
            },
            {
                key: TOOLS.ZOOM_PART.TOOL,
                event: this.zoomPart()
            }
        ]
    }

    goPage() {
        return () => {
            EventBus.getInstance().getAppRefs().toolBar.toggleQuickDirectory();
        }
    }

    goLeftPage() {
        Debugger.Instance.log("go left page", "page_tool");
        const self = this;
        return () => {
            EventBus.getInstance().getAppRefs().soundManager.isEnd = true;
            // TODO: 依照課本翻頁模式調整
            if (store.turnPageType == TURN_PAGE_TYPE.TURN_RIGHT) {
                self.goPrevPage();
            } else if (store.turnPageType == TURN_PAGE_TYPE.TURN_LEFT) {
                self.goNextPage();
            }
        }
    }

    goRightPage() {
        Debugger.Instance.log("go right page", "page_tool");
        const self = this;
        return () => {
            EventBus.getInstance().getAppRefs().soundManager.isEnd = true;
            // TODO: 依照課本翻頁模式調整
            if (store.turnPageType == TURN_PAGE_TYPE.TURN_RIGHT) {
                self.goNextPage();
            } else if (store.turnPageType == TURN_PAGE_TYPE.TURN_LEFT) {
                self.goPrevPage();
            }
        }
    }

    showDirectory() {
        return () => {
            EventBus.getInstance().getAppRefs().directory.show = true;
        }
    }

    goPageByIndex() {
        return (index) => {
            window.pageControl.gotoPage(index)
        }
    }

    zoomIn() {
        return () => {
            EventBus.getInstance().getAppRefs().bookPage.zoomIn();
        }
    }

    zoomOut() {
        return () => {
            EventBus.getInstance().getAppRefs().bookPage.zoomOut();
        }
    }

    zoomNormal() {
        return () => {
            focusStore.focusBookPage.zoomNormal();
        }
    }

    zoomCorner(corner) {
        switch (corner) {
            case TOOLS.ZOOM_CORNER.TOOL + ":" + CORNER.LEFT_TOP:
                return () => {
                    if (store.singlePageMode && store.singlePageIndex == 1) return;
                    focusStore.focusBookPage.zoomCornerLeftTop();
                }
            case TOOLS.ZOOM_CORNER.TOOL + ":" + CORNER.RIGHT_TOP:
                return () => {
                    console.log(focusStore);
                    if (store.singlePageMode && store.singlePageIndex == 0) return;
                    // focusStore.focusBookPage.zoomCornerRightTop();
                    focusStore.focusBookPage.zoomCornerRightTop();
                }
            case TOOLS.ZOOM_CORNER.TOOL + ":" + CORNER.LEFT_BOTTOM:
                return () => {
                    if (store.singlePageMode && store.singlePageIndex == 1) return;
                    focusStore.focusBookPage.zoomCornerLeftBottom();
                }
            case TOOLS.ZOOM_CORNER.TOOL + ":" + CORNER.RIGHT_BOTTOM:
                return () => {
                    if (store.singlePageMode && store.singlePageIndex == 0) return;
                    focusStore.focusBookPage.zoomCornerRightBottom();
                }
        }

    }

    exit() {
        const self = this;
        Debugger.Instance.log("exit", "page_tool");
        return () => {
            switch (store.nowView) {
                case VIEW_TYPE.PC:
                case VIEW_TYPE.MAC:
                case VIEW_TYPE.WEB:
                    EventBus.getInstance().emit("save_record");
                    // window.ipcRenderer.send(IPC_EVENT.EXIT);
                    break;
                case VIEW_TYPE.ANDROID:
                case VIEW_TYPE.IOS:
                    self._exitDialog.showDialog();
                    // AppRenderer.Instance.backToBookcase();
                    break;
                default:
                    console.error("exit type error!");
                    break;
            }
        }
    }

    switchFullScreenOrWindow() {
        Debugger.Instance.log("switch full screen or window", "page_tool");
        return () => {
            settingStore.isWindow = 1 - settingStore.isWindow;
            // AppRenderer.Instance.switchFullScreenOrWindow();
            //store.toggleTool[TOOLS.FULL_SCREEN.TOOL] = true;
        }
    }

    switchSingleOrDoublePage() {
        Debugger.Instance.log("switch single page or double page", "page_tool");
        return () => {
            store.setSinglePageMode(!store.singlePageMode);
            store.singlePageIndex = 0;

            // AppRenderer.Instance.switchFullScreenOrWindow();
            //store.toggleTool[TOOLS.FULL_SCREEN.TOOL] = true;
        }
    }

    zoomPart() {
        const proxy = PainterProxy.getInstance();
        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(null);
            const canvas = proxy.getCurrentPainter().painter.canvas;
            proxy.getCurrentPainter().painter.isInteractive = false;
            const objects = canvas.getObjects();
            for (let i = 0; i < objects.length; i++) {
                objects[i].set('selectable', false);
            }
        }
    }

    goNextPage() {
        //如果書未載進來禁止翻頁
        if (focusStore.mainBookPage == null) {
            return;
          }

        window.soundManager.audioPlayerStop();

        if (store.singlePageMode) {
            console.log(store.singlePageIndex)
            if (store.singlePageIndex == 0) {
                store.setSinglePageIndex(1);
                //翻頁時不清除 操作記錄
                //window.pageControl.doChangePage();
            } else {
                store.setSinglePageIndex(0);
                store.switchSinglePageTrigger(true);
                window.loader.isLoadNewPage = true;
                window.pageControl.gotoPage(window.pageControl.nextPage);
            }
        } else {
            window.pageControl.gotoPage(window.pageControl.nextPage);
        }
    }

    goPrevPage() {
        //如果書未載進來禁止翻頁
        if (focusStore.mainBookPage == null) {
            return;
          }

        window.soundManager.audioPlayerStop();
        if (store.singlePageMode) {
            if (store.singlePageIndex == 1) {
                store.setSinglePageIndex(0);
                //翻頁時不清除 操作記錄
                //window.pageControl.doChangePage();
            } else {
                store.setSinglePageIndex(1);
                store.switchSinglePageTrigger(true);
                window.loader.isLoadNewPage = true;
                window.pageControl.gotoPage(window.pageControl.prevPage);
            }
        } else {
            window.pageControl.gotoPage(window.pageControl.prevPage);
        }
    }
}